module.exports = __webpack_public_path__ + "img/artur.7b7db12b.jpeg";